/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingInfo_regionalInfo = ReadonlyArray<{
    readonly regionsByZipCode: ReadonlyArray<{
        readonly displayName: string | null;
    } | null> | null;
    readonly " $refType": "PdpSharedShippingInfo_regionalInfo";
}>;
export type PdpSharedShippingInfo_regionalInfo$data = PdpSharedShippingInfo_regionalInfo;
export type PdpSharedShippingInfo_regionalInfo$key = ReadonlyArray<{
    readonly " $data"?: PdpSharedShippingInfo_regionalInfo$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_regionalInfo">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "PdpSharedShippingInfo_regionalInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RegionsByZipCode",
      "kind": "LinkedField",
      "name": "regionsByZipCode",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RegionalInfo",
  "abstractKey": null
};
(node as any).hash = '4143037d705b38feb17a86b3be36f145';
export default node;
